var map = {
	"./backups0.png": "PJxJ",
	"./backups1.png": "ePms"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ym9l";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/left ^\.\/backups.*\.png$
// module id = ym9l
// module chunks = 3